import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../redux/axios";

const initialState = {
  billingData: [], 
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: "",
  
  createBilling: {},
  isFetchingCreate: false,
  isSuccessCreateBilling: false,
  isErrorCreateBilling: false,
  isErrorMessageCreateBilling: "",
  
  deleteBilling: {},
  isFetchingDelete: false,
  isSuccessDeleteBilling: false,
  isErrorDeleteBilling: false,
  isErrorMessageDeleteBilling: "",
  
  editBilling: {},
  isFetchingEdit: false,
  isSuccessEditBilling: false,
  isErrorEditBilling: false,
  isErrorMessageEditBilling: "",
};

export const getBillingData = createAsyncThunk(
  "billing/get-all-billing", 
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.billing.accessToken;
      let url = `/billing/get-all-billing`;

      if (udata) {
        url = `/billing/get-all-billing${udata}`;
      }

      const { data, status } = await axios.get(url, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const createBillingData = createAsyncThunk(
  "billing/create-billing",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.billing.accessToken;

      const { data, status } = await axios.post(
        "/billing/create-billing",
        udata,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }

      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const deleteBillingData = createAsyncThunk(
  "billing/delete-billing",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.billing.accessToken;

      const { data, status } = await axios.delete(
        `/billing/delete-billing/${udata.id}`,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const updateBillingData = createAsyncThunk(
  "billing/update-billing",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.billing.accessToken;
      const { data, status } = await axios.put(
        `/billing/update-billing/${udata.id}`,
        {
          title: udata.title,
          message: udata.message,
        },
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const billingSlice = createSlice({
  name: "billing",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBillingData.fulfilled, (state, action) => {
        state.billingData = action.payload.data;
        state.isFetching = false;
        state.isSuccess = true;
      })
      .addCase(getBillingData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getBillingData.rejected, (state, action) => {
        state.billingData = [];
        state.isFetching = false;
        state.isError = true;
        state.errorMessage = action.payload
          ? action.payload.message
          : "Internal error";
      })

      
      .addCase(createBillingData.fulfilled, (state, action) => {
        state.createBilling = action.payload;
        state.isFetching = false;
        state.isSuccessCreateBilling = true;
      })
      .addCase(createBillingData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(createBillingData.rejected, (state, action) => {
        state.isFetching = false;
        state.isErrorCreateBilling = true;
        state.isErrorMessageCreateBilling = action.payload
          ? action.payload.message
          : "Internal error";
      })

      
      .addCase(deleteBillingData.fulfilled, (state, action) => {
        state.deleteBilling = action.payload;
        state.isFetching = false;
        state.isSuccessDeleteBilling = true;

        if (state.billingData.length === 1) state.billingData = [];
      })
      .addCase(deleteBillingData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(deleteBillingData.rejected, (state, action) => {
        state.isFetching = false;
        state.isErrorDeleteBilling = true;
        state.isErrorMessageDeleteBilling = action.payload
          ? action.payload.message
          : "Internal error";
      })

     
      .addCase(updateBillingData.fulfilled, (state, action) => {
        state.editBilling = action.payload;
        state.isFetching = false;
        state.isSuccessEditBilling = true;
        state.isErrorMessageEditBilling = action.payload.data;
      })
      .addCase(updateBillingData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(updateBillingData.rejected, (state, action) => {
        state.isFetching = false;
        state.isErrorEditBilling = true;
        state.isErrorMessageEditBilling = action.payload.data
          ? action.payload.message
          : "Internal error";
      });
  },
});

export const billingSelector = (state) => state.billing;

export default billingSlice.reducer;
